export type Vector3Tuple = [number, number, number];

export interface StarPoint {
  position: Vector3Tuple;
  size: number;
  hue: number;
}

const GOLDEN_ANGLE = Math.PI * (3 - Math.sqrt(5));

export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

export function mapRange(
  value: number,
  inputMin: number,
  inputMax: number,
  outputMin: number,
  outputMax: number,
): number {
  if (inputMax === inputMin) {
    return outputMin;
  }

  const progress = (value - inputMin) / (inputMax - inputMin);
  return outputMin + clamp(progress, 0, 1) * (outputMax - outputMin);
}

export function generateGalaxyPoints(count: number, radius: number): StarPoint[] {
  return Array.from({ length: count }, (_, index) => {
    const progress = (index + 0.5) / count;
    const spiralRadius = Math.sqrt(progress) * radius;
    const angle = index * GOLDEN_ANGLE;
    const armRipple = Math.sin(progress * Math.PI * 12) * 0.28;
    const depth = Math.cos(angle * 0.7) * radius * 0.18 + armRipple;

    return {
      position: [
        Math.cos(angle) * spiralRadius,
        Math.sin(angle) * spiralRadius,
        depth,
      ],
      size: mapRange(progress, 0, 1, 0.018, 0.072),
      hue: mapRange(Math.sin(angle) + armRipple, -1.28, 1.28, 180, 318),
    };
  });
}
